import { GENDER_IDENTITY } from '../questionnaire/Constants';

export const TWIN_TYPES = Object.freeze({
  identical: 'identical',
  nonIdentical: 'non-identical',
  unknown: 'unknown'
});

export const TWIN_IDENTIFIERS = Object.freeze({
  mztwin: 'mztwin',
  dztwin: 'dztwin',
  cztwin: 'cztwin'
});

const DECEASED_ALIASES = new Set(['false', 'no', '0']);

export const resolveVitalStatus = ({ isAlive, dod } = {}) => {
  if (dod) return 'false';
  if (isAlive === null || isAlive === undefined || isAlive === '')
    return 'true';
  return DECEASED_ALIASES.has(String(isAlive).trim().toLowerCase())
    ? 'false'
    : 'true';
};

// map of relations used in the pedigree
export const RELATIONS = {
  children: 'children',
  siblings: 'siblings',
  halfSiblings: 'halfSiblings',
  partner: 'spouse',
  parent: 'parent',
  mothersParent: 'mothersParent',
  fathersParent: 'fathersParent',
  parentsSibling: 'parentsSibling',
  otherAffected: 'otherAffected'
};

export const diagnosesColorMap = [
  { type: 'breast-cancer', colour: '#ff6e6e' },
  { type: 'pancreatic-cancer', colour: '#f7e406' },
  { type: 'colon-cancer', colour: '#2baabf' },
  { type: 'ovarian-cancer', colour: '#f50257' },
  { type: 'prostate-cancer', colour: '#002884' },
  { type: 'polyps', colour: '#002114' },
  { type: 'heart-problems', colour: '#3f50b5' },
  { type: 'eye-problems', colour: '#ba000d' },
  { type: 'kidney-problems', colour: '#4caf50' },
  { type: 'neurological-conditions', colour: '#8b06f7' },
  { type: 'other', colour: '#f78706' },
  { type: 'blood-disorders', colour: '#ff0000' },
  { type: 'stillbirth', colour: '#253559' },
  { type: 'recurrent-misscarriage', colour: '#91e83a' },
  { type: 'congenital-abnormalities', colour: '#63f282' },
  { type: 'endometrial-cancer', colour: '#ffd480' },
  { type: 'hemophilia_a', colour: '#ff5e5e' },
  { type: 'hemophilia_b', colour: '#006FA2' },
  { type: 'fibrinogen_disorder', colour: '#ffa55e' },
  { type: 'von_willebrand_disease', colour: '#ffcc99' },
  { type: 'glanzmann_thrombasthenia', colour: '#ffebcc' },
  { type: 'bernard_soulier_syndrome', colour: '#f0fff0' },
  { type: 'hereditary_hemorrhagic_telangiectasia', colour: '#d1ffd1' },
  { type: 'platelet_function_disorder', colour: '#FAA000' },
  { type: 'neutropenia', colour: '#90C244' },
  { type: 'protein_c_deficiency', colour: '#F4D401' },
  { type: 'protein_s_deficiency', colour: '#58BF8D' },
  { type: 'antithrombin_iii_deficiency', colour: '#89F008' },
  { type: 'factor_v_leiden', colour: '#FC86FE' },
  { type: 'prothrombin_gene_variant', colour: '#A86B5C' },
  { type: 'low_platelet_count_(thrombocytopenia)', colour: '#FE8486' },
  { type: 'blood_clot_(thrombosis)', colour: '#EEA356' }
];

export const diagnsesShapeMap = {
  // 'breast-cancer': { shape: 'q1', color: '#ff4747' },
  // 'pancreatic-cancer': { shape: 'q2', color: '#f7e406' },
  // 'colon-cancer': { shape: 'q3', color: '#2baabf' },
  // 'ovarian-cancer': { shape: 'q4', color: '#f50257' },
  // 'prostate-cancer': { shape: 'dot', color: '#002884' },
  // 'heart-problems': { shape: 'q1', color: '#3f50b5' },
  // 'eye-problems': { shape: 'q2', color: '#ba000d' },
  // 'kidney-problems': { shape: 'q3', color: '#4caf50' },
  // 'neurological-conditions': { shape: 'q4', color: '#8b06f7' },
  // other: { shape: 'dot', color: '#f78706' },
  // 'blood-disorders': { shape: 'q1', color: '#ff0000' },
  // stillbirth: { shape: 'q2', color: '#253559' },
  // 'recurrent-misscarriage': {
  //   shape: 'q3',
  //   color: '#91e83a'
  // },
  // 'congenital-abnormalities': {
  //   shape: 'q4',
  //   color: '#63f282'
  // },
  // 'endometrial-cancer': { shape: 'dot', color: '#ffd480' }
  'breast-cancer': '#ff6e6e',
  'pancreatic-cancer': '#f7e406',
  'colon-cancer': '#2baabf',
  'ovarian-cancer': '#f50257',
  'prostate-cancer': '#002884',
  'heart-problems': '#3f50b5',
  polyps: '#002114',
  'eye-problems': '#ba000d',
  'kidney-problems': '#4caf50',
  'neurological-conditions': '#8b06f7',
  other: '#f78706',
  'blood-disorders': '#ff0000',
  stillbirth: '#253559',
  'recurrent-misscarriage': '#91e83a',
  'congenital-abnormalities': '#63f282',
  'endometrial-cancer': '#ffd480',
  hemophilia_a: '#ff5e5e',
  hemophilia_b: '#006FA2',
  fibrinogen_disorder: '#ffa55e',
  von_willebrand_disease: '#ffcc99',
  glanzmann_thrombasthenia: '#ffebcc',
  bernard_soulier_syndrome: '#f0fff0',
  hereditary_hemorrhagic_telangiectasia: '#d1ffd1',
  platelet_function_disorder: '#FAA000',
  neutropenia: '#90C244',
  protein_c_deficiency: '#F4D401',
  protein_s_deficiency: '#58BF8D',
  antithrombin_iii_deficiency: '#89F008',
  factor_v_leiden: '#FC86FE',
  prothrombin_gene_variant: '#A86B5C',
  'low_platelet_count_(thrombocytopenia)': '#FE8486',
  'blood_clot_(thrombosis)': '#EEA356'
};

// map of all relations - coming from fhq
export const relationMap = {
  self: RELATIONS.siblings,
  mother: RELATIONS.parent,
  father: RELATIONS.parent,
  son: RELATIONS.children,
  daughter: RELATIONS.children,
  fullSister: RELATIONS.siblings,
  fullBrother: RELATIONS.siblings,
  halfSister: RELATIONS.halfSiblings,
  halfBrother: RELATIONS.halfSiblings,
  spouse: RELATIONS.partner,
  mothersMother: RELATIONS.mothersParent,
  mothersFather: RELATIONS.mothersParent,
  fathersMother: RELATIONS.fathersParent,
  fathersFather: RELATIONS.fathersParent,
  mothersBrother: RELATIONS.parentsSibling,
  mothersSister: RELATIONS.parentsSibling,
  fathersBrother: RELATIONS.parentsSibling,
  fathersSister: RELATIONS.parentsSibling,
  otherAffected: RELATIONS.otherAffected
};

// offset used for the editor's position
export const offset = 500;
export const boxSize = { w: '100%', h: 950 };

// NOTE: dead code — no current consumer imports this (its only callers lived in
// the legacy src/components/pedigree/ tree, now removed). Safe to delete in a
// follow-up. If it is ever revived, mint the uid via mintObjectIdHex
// (pedigree-tool/pedigree/saveReconciliation.js) so members are born with a
// stable ObjectId-shaped identity.
export const generateNewUser = (
  gender,
  user_id,
  relation = 'otherAffected'
) => {
  const user = {
    firstName: null,
    pid: crypto.randomUUID(),
    relationship: relation,
    diagnoses: [],
    gender: gender,
    genderIdentity: GENDER_IDENTITY[gender] ?? GENDER_IDENTITY.unknown,
    user_id: user_id
  };

  return user;
};

export const relationship = {
  mother: 'mother',
  father: 'father',
  son: 'son',
  daughter: 'daughter',
  fullSister: 'fullSister',
  fullBrother: 'fullBrother',
  halfSister: 'halfSister',
  halfBrother: 'halfBrother',
  spouse: 'spouse',
  mothersMother: 'mothersMother',
  mothersFather: 'mothersFather',
  fathersMother: 'fathersMother',
  fathersFather: 'fathersFather',
  mothersBrother: 'mothersBrother',
  mothersSister: 'mothersSister',
  fathersBrother: 'fathersBrother',
  fathersSister: 'fathersSister',
  otherAffected: 'otherAffected'
};

export const defaultPedigreeSettings = {
  targetDiv: 'pedigreeChart',
  width: boxSize.w,
  height: boxSize.h,
  symbol_size: 45,
  fontSize: 70,
  zoomSrc: ['wheel'],
  zoomIn: 0.2,
  zoomOut: 1.0,
  diseases: diagnosesColorMap,
  horizontal_spacing: 100,
  vertical_spacing: 100
};

export const DEFAULT_CANVAS_PREFERENCES = {
  symbol_size: 155,
  font_size: 70,
  horizontal_spacing: 100,
  vertical_spacing: 100,
  enable_grid: false,
  // Default ON: node spacing (H×V) is derived from label density/length instead of
  // the manual percentages, so charts space themselves to fit their labels out of
  // the box. Users can turn it off in Pedigree Settings to set H×V manually.
  auto_spacing: true
};
